import { render } from "./FatturazioneExtra.vue?vue&type=template&id=93ece5c0&scoped=true"
import script from "./FatturazioneExtra.vue?vue&type=script&lang=js"
export * from "./FatturazioneExtra.vue?vue&type=script&lang=js"

import "./FatturazioneExtra.vue?vue&type=style&index=0&id=93ece5c0&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ece5c0"]])

export default __exports__